// TwoPointCircleMarker.js
import { GalleryMarkerBase } from './GalleryMarkerBase.js';

// Read-only Viewpoint mit 2 Punkten: nur der Origin-Marker. Die Kreis-Form zeichnet die zentrale LocationShapeLayer
// (früher hier eine google.maps.Circle im overlayLayer, die unter den getilten Overlays lag).
export class TwoPointCircleMarker extends GalleryMarkerBase {
    draw(map) {
        const center = this.mapAdapter.createLatLng(this.points[0].lat, this.points[0].lng);
        const originMarker = this.createOriginMarker(center);
        this.drawnElements.push(originMarker);
    }

    // Fit-Bounds = der GANZE Kreis (Center ± Radius), nicht nur die Radius-Linie (Center→Edge). Erhält das bisherige
    // Fit-Verhalten: da die sichtbare Circle in die LocationShapeLayer gewandert ist, wird hier ein map-LOSER
    // google.maps.Circle nur zur Bounds-Berechnung erzeugt (nicht gezeichnet).
    getBounds() {
        const center = this.mapAdapter.createLatLng(this.points[0].lat, this.points[0].lng);
        const edge = this.mapAdapter.createLatLng(this.points[1].lat, this.points[1].lng);
        const radius = this.mapAdapter.getDistance(center, edge);
        return new google.maps.Circle({ center, radius }).getBounds();
    }
}
